import { useState, useEffect, useRef, useCallback } from 'react';
import { Calendar } from "primereact/calendar";
import { MultiSelect } from "primereact/multiselect";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { FileUpload } from "primereact/fileupload";
import { Button } from "primereact/button";
import Loader from "../../Shared/Loader/Loader";
import APIConstant from "../../../utils/pathConstants";
import api from "../../../utils/apiClient";
import CommonConfig from '../../../utils/constant';
import moment from 'moment';
import Toast from '../../Shared/Toast/Toast';
import { apiBase } from '../../../utils/config';
import DeleteConfirmation from '../../Dialogs/DeleteConfirmation';
import { Dialog } from 'primereact/dialog';
import { useCatchResponse } from '../../../utils/useCatchResponse';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Checkbox } from 'primereact/checkbox';
import ExcelJS from 'exceljs';

const AddEditAcademicCalender = (props) => {
    const { catchResponse } = useCatchResponse();
    const [securityUserID, setSecurityUserID] = useState("");
    const importFileUploadRef = useRef(null);
    const [formData, setFormData] = useState({
        academicYearName: "",
        academicYearNameErr: false,
        academicYearNameErrText: '',
        calendarTemplateValues: [
            {
                dateRange: null,
                dateRangeErr: false,
                dateRangeErrText: '',
                classesApplicable: [],
            }
        ],
        importURL: "",
        importFile: null,
        classType: 'sectionWise'
    });
    const [overlapKeys, setOverlapKeys] = useState([]);
    const [classList, setClassList] = useState([]);
    const [isDeleteConfirmation, setIsDeleteConfirmation] = useState(false);
    const [isDeleteExcelConfirmation, setIsDeleteExcelConfirmation] = useState(false);
    const academicYearNameRef = useRef(null);

    const [academicStartDate, setAcademicStartDate] = useState(null);
    const [academicEndDate, setAcademicEndDate] = useState(null);
    const [isDeleteHolidayConfirmation, setIsDeleteHolidayConfirmation] = useState(false);
    const [deletedIndex, setDeletedIndex] = useState(null);
    const [excelData, setExcelData] = useState([]);
    const [excelFileName, setExcelFileName] = useState("");
    const [holidaySettings, setHolidaySettings] = useState({
        EverySunday: true,
        FirstSaturday: false,
        SecondSaturday: false,
        ThirdSaturday: false,
        FourthSaturday: false
    });

    useEffect(() => {
        const loginData = CommonConfig.loginData();
        setSecurityUserID(loginData?._id);
        setTimeout(() => {
            academicYearNameRef.current?.focus();
        }, 100);
    }, []);

    useEffect(() => {
        const loginData = CommonConfig.loginData();
        setSecurityUserID(loginData?._id);
        if (props?.configId) {
            GetAcademicCalanderDetail(props?.configId, loginData?._id);
        } else {
            GetClassList(loginData?._id, 'sectionWise');
        }
    }, []);

    useEffect(() => {
        if (!formData?.holidayErr) {
            const dateRange = formData.calendarTemplateValues[0]?.dateRange;
            if (dateRange && dateRange[0]) {
                const [startDate, endDate] = dateRange;
                const newHolidays = generateHolidayRecords(startDate, endDate, holidaySettings);

                setExcelData(prevData => {
                    const manualRecords = prevData.filter(rec => !rec.isAutoGenerated);
                    const filteredManual = removeDuplicateHolidays(manualRecords, newHolidays);
                    const combined = [...filteredManual, ...newHolidays];
                    const uniqueRecords = removeDuplicates(combined);

                    const sorted = uniqueRecords
                        .sort((a, b) => parseDMY(a.StartDate) - parseDMY(b.StartDate))
                        .map((rec, idx) => ({ ...rec, srNo: idx + 1 }));

                    return sorted;
                });
            } else {
                setExcelData([]);
            }
        }
    }, [formData.calendarTemplateValues, holidaySettings]);

    useEffect(() => {
        const academicCalendar = formData.calendarTemplateValues || [];

        if (!academicCalendar.length) {
            setAcademicStartDate(null);
            setAcademicEndDate(null);
            return;
        }

        const validRanges = academicCalendar.filter(
            item => item?.dateRange && item.dateRange[0]
        );

        if (!validRanges.length) {
            setAcademicStartDate(null);
            setAcademicEndDate(null);
            return;
        }

        const sortedCalendar = [...validRanges].sort(
            (a, b) =>
                new Date(a.dateRange[0]) - new Date(b.dateRange[0])
        );

        const start = new Date(sortedCalendar[0].dateRange[0]);

        const lastRange = sortedCalendar[sortedCalendar.length - 1];
        const end = new Date(
            lastRange.dateRange[1] || lastRange.dateRange[0]
        );

        setAcademicStartDate(start);
        setAcademicEndDate(end);

    }, [formData?.calendarTemplateValues]);

    const removeDuplicates = (records) => {
        const map = new Map();

        records.forEach(rec => {
            const key = `${rec.StartDate}_${rec.EndDate}_${rec.HolidayName}`;
            if (!map.has(key)) {
                map.set(key, rec);
            }
        });

        return Array.from(map.values());
    };

    const generateHolidayRecords = (startDate, endDate, settings) => {
        try {
            if (!startDate) return [];

            const records = [];

            const formatDDMMYYYY = (date) => {
                const day = String(date.getDate()).padStart(2, '0');
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const year = date.getFullYear();
                return `${day}/${month}/${year}`;
            };

            const createSafeDate = (dateInput) => {
                if (!dateInput) return null;

                if (dateInput instanceof Date) {
                    return new Date(dateInput.getFullYear(), dateInput.getMonth(), dateInput.getDate());
                }

                if (typeof dateInput === 'string') {
                    const val = dateInput.trim();

                    if (/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(val)) {
                        const [d, m, y] = val.split('/').map(Number);
                        return new Date(y, m - 1, d);
                    }

                    if (/^\d{1,2}-\d{1,2}-\d{4}$/.test(val)) {
                        const [d, m, y] = val.split('-').map(Number);
                        return new Date(y, m - 1, d);
                    }

                    const date = new Date(val);
                    if (!isNaN(date)) {
                        return new Date(date.getFullYear(), date.getMonth(), date.getDate());
                    }

                    return null;
                }

                const date = new Date(dateInput);
                if (!isNaN(date)) {
                    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
                }

                return null;
            };

            const start = createSafeDate(startDate);
            const end = endDate ? createSafeDate(endDate) : createSafeDate(startDate);

            if (!start || !end || isNaN(start.getTime()) || isNaN(end.getTime())) {
                Toast.error('Invalid date provided. Please check your dates.');
                return [];
            }

            let currentDate = new Date(start);
            let srNo = 1;

            while (currentDate <= end) {
                const dayOfWeek = currentDate.getDay();
                const dateOfMonth = currentDate.getDate();
                const weekOfMonth = Math.ceil(dateOfMonth / 7);

                let shouldAddHoliday = false;
                let holidayName = '';

                if (settings.EverySunday && dayOfWeek === 0) {
                    shouldAddHoliday = true;
                    holidayName = 'Sunday Holiday';
                } else if (dayOfWeek === 6) {
                    if (settings.FirstSaturday && weekOfMonth === 1) {
                        shouldAddHoliday = true;
                        holidayName = '1st Saturday Holiday';
                    } else if (settings.SecondSaturday && weekOfMonth === 2) {
                        shouldAddHoliday = true;
                        holidayName = '2nd Saturday Holiday';
                    } else if (settings.ThirdSaturday && weekOfMonth === 3) {
                        shouldAddHoliday = true;
                        holidayName = '3rd Saturday Holiday';
                    } else if (settings.FourthSaturday && weekOfMonth === 4) {
                        shouldAddHoliday = true;
                        holidayName = '4th Saturday Holiday';
                    }
                }

                if (shouldAddHoliday) {
                    const formattedDate = formatDDMMYYYY(currentDate);

                    records.push({
                        srNo: srNo++,
                        StartDate: formattedDate,
                        EndDate: formattedDate,
                        Name: holidayName,
                        Remark: 'Auto-generated from holiday settings',
                        Type: 'Holiday',
                        isEdit: false,
                        isAutoGenerated: true
                    });
                }

                currentDate.setDate(currentDate.getDate() + 1);
            }

            return records;
        } catch (error) {
            console.log('error in catch: ', error);
            Toast.error('Error generating holiday records. Please try again.');
            return [];
        }
    };

    const removeDuplicateHolidays = (existingRecords, newRecords) => {
        const filtered = existingRecords.filter(existing => {
            const existingStart = new Date(existing.StartDate);
            const existingEnd = new Date(existing.EndDate || existing.StartDate);

            return !newRecords.some(newRec => {
                const newStart = new Date(newRec.StartDate);
                const newEnd = new Date(newRec.EndDate || newRec.StartDate);

                return (
                    (existingStart >= newStart && existingStart <= newEnd) ||
                    (existingEnd >= newStart && existingEnd <= newEnd) ||
                    (newStart >= existingStart && newStart <= existingEnd)
                );
            });
        });

        return filtered;
    };

    const GetAcademicCalanderDetail = async (id, userId) => {
        try {
            let data = {
                id: id,
            }
            await api.post(APIConstant.path.getAcademicCalanderConfigurationById, data).then(async response => {
                let res = response;
                if (res.success) {
                    const detailData = res.data;
                    let formatedCalendar = detailData?.CalendarValue?.map((x) => {
                        return {
                            dateRange: [x?.StartDate ? new Date(x?.StartDate) : null, x?.EndDate ? new Date(x?.EndDate) : null],
                            classesApplicable: x?.ApplicableClass?.split(',') || []
                        }
                    });
                    formatedCalendar = formatedCalendar.length ? formatedCalendar : [{
                        dateRange: null,
                        dateRangeErr: false,
                        dateRangeErrText: '',
                        classesApplicable: [],
                    }]
                    setFormData((prev) => ({
                        ...prev,
                        academicYearName: detailData?.TitleName,
                        importURL: detailData?.ImportUrl,
                        importFile: detailData?.ImportFile ? `${apiBase}/Documents/${detailData?.ImportFile}` : null,
                        calendarTemplateValues: formatedCalendar,
                        classType: detailData?.ClassType
                    }));

                    if (detailData?.HolidaySettings) {
                        setHolidaySettings(detailData.HolidaySettings);
                    }

                    if (detailData?.HolidayData) {
                        const excelData = detailData?.HolidayData?.map((z, idx) => ({
                            ...z,
                            srNo: idx + 1,
                            StartDate: z?.StartDate ? normalizeDate(z?.StartDate) : '',
                            EndDate: z?.EndDate ? normalizeDate(z?.EndDate) : '',
                            Type: z?.Type || 'Holiday'
                        }));
                        setExcelData(excelData);
                    }
                    GetClassList(userId, detailData?.ClassType);
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const handleClose = () => {
        setIsDeleteConfirmation(false)
    };

    const handleCloseExcelConfirmation = () => {
        setIsDeleteExcelConfirmation(false);
    };

    const handleCloseHolidayConfirmation = () => {
        setIsDeleteHolidayConfirmation(false);
        setDeletedIndex(null);
    };

    const GetClassList = async (id, type) => {
        try {
            let data = {
                UserID: id,
            }
            await api.post(APIConstant.path.getClassList, data).then(async response => {
                let res = response;
                if (res.success) {
                    if (type == 'sectionWise') {
                        let classData = res?.data?.filter(x => x?.Status === 'Active')?.map((x) => ({
                            value: x?._id,
                            label: `${x?.ClassName}-${x?.SectionFullName}-${x?.MediumName}-${x?.Board}`
                        }));
                        setClassList(classData);
                    } else {
                        setClassList(
                            Array.from(
                                new Map(
                                    res?.data?.filter(x => x?.Status === 'Active')?.map((x) => [
                                        x?.ClassId,
                                        {
                                            value: x?.ClassId,
                                            label: `${x?.ClassName}-${x?.MediumName}-${x?.Board}`
                                        }
                                    ])
                                ).values()
                            )
                        );
                    }
                    setFormData((prev) => {
                        const updatedCalendarTemplateValues = [...prev.calendarTemplateValues];
                        updatedCalendarTemplateValues?.map(y => ({
                            ...y,
                            isClassUpdated: !y?.isClassUpdated,
                        }))
                        return {
                            ...prev,
                            classType: type,
                            calendarTemplateValues: updatedCalendarTemplateValues
                        };
                    });
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const normalizeDateOnly = (dateStr) => {
        if (!dateStr) return null;

        if (dateStr instanceof Date && !isNaN(dateStr)) {
            return new Date(
                dateStr.getFullYear(),
                dateStr.getMonth(),
                dateStr.getDate()
            );
        }

        if (typeof dateStr === 'string') {
            const val = dateStr.trim();

            if (/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(val)) {
                const [d, m, y] = val.split('/').map(Number);
                return new Date(y, m - 1, d);
            }

            if (/^\d{1,2}-\d{1,2}-\d{4}$/.test(val)) {
                const [d, m, y] = val.split('-').map(Number);
                return new Date(y, m - 1, d);
            }
        }

        return null; // invalid
    };

    const checkOverlappingHolidays = (records) => {
        const ranges = records
            .filter(r => r?.StartDate)
            .map(r => ({
                start: normalizeDateOnly(r.StartDate),
                end: normalizeDateOnly(r.EndDate || r.StartDate)
            }));

        for (let i = 0; i < ranges.length; i++) {
            for (let j = i + 1; j < ranges.length; j++) {
                const a = ranges[i];
                const b = ranges[j];

                if (a.start <= b.end && a.end >= b.start) {
                    return true;
                }
            }
        }
        return false;
    };

    const getRowKey = (row) => `${row.StartDate}_${row.EndDate}_${row.Name}`;

    const getOverlappingKeys = (records) => {
        const ranges = records.map((r) => ({
            key: getRowKey(r),
            start: normalizeDateOnly(r.StartDate),
            end: normalizeDateOnly(r.EndDate || r.StartDate),
        })).filter(r => r.start && r.end);

        const overlaps = new Set();

        for (let i = 0; i < ranges.length; i++) {
            for (let j = i + 1; j < ranges.length; j++) {
                const a = ranges[i];
                const b = ranges[j];

                if (a.start <= b.end && a.end >= b.start) {
                    overlaps.add(a.key);
                    overlaps.add(b.key);
                }
            }
        }

        return Array.from(overlaps);
    };


    const validate = () => {
        let formIsValid = true;
        if (CommonConfig.isEmpty(formData?.academicYearName)) {
            formIsValid = false;
            setFormData((prev) => ({ ...prev, academicYearNameErr: true, academicYearNameErrText: 'Name is required' }));
        } else {
            setFormData((prev) => ({ ...prev, academicYearNameErr: false, academicYearNameErrText: '' }));
        }

        const updatedCalendarValues = formData.calendarTemplateValues.map((item) => {
            const dateRange = item.dateRange;
            let dateRangeErr = false;
            let dateRangeErrText = '';

            if (!dateRange || !dateRange[0]) {
                formIsValid = false;
                dateRangeErr = true;
                dateRangeErrText = 'Start date is required';
            } else if (!dateRange[1]) {
                formIsValid = false;
                dateRangeErr = true;
                dateRangeErrText = 'End date is required';
            } else if (new Date(dateRange[0]).getTime() === new Date(dateRange[1]).getTime()) {
                formIsValid = false;
                dateRangeErr = true;
                dateRangeErrText = "'Start' and 'End' date cannot be the same";
            } else if (new Date(dateRange[0]) > new Date(dateRange[1])) {
                formIsValid = false;
                dateRangeErr = true;
                dateRangeErrText = "'Start' date cannot be after 'End' date";
            }

            return {
                ...item,
                dateRangeErr,
                dateRangeErrText
            };
        });

        setFormData((prev) => ({
            ...prev,
            calendarTemplateValues: updatedCalendarValues
        }));

        const validHolidayData = (excelData || []).filter(
            item => item?.StartDate?.toString().trim()
        );

        const invalidExcelRecords = validHolidayData.filter(rec => {
            if (!rec.isAutoGenerated) {
                if (!rec.StartDate) return true;
                if (rec.EndDate) {
                    const start = new Date(rec.StartDate);
                    const end = new Date(rec.EndDate);
                    if (start > end) return true;
                }
            }
            return false;
        });

        if (invalidExcelRecords.length > 0) {
            formIsValid = false;
            setFormData((prev) => ({
                ...prev,
                holidayErr: true,
                holidayErrText: 'Some holiday records have invalid dates. Please check and fix them.'
            }));
        }

        const uniqueRecords = removeDuplicates(excelData);
        if (excelData.length !== uniqueRecords.length) {
            formIsValid = false;
            setFormData((prev) => ({
                ...prev,
                holidayErr: true,
                holidayErrText: 'Some holiday records are duplicats. Please check and fix them.'
            }));
        }

        const hasOverlap = checkOverlappingHolidays(validHolidayData);

        if (hasOverlap) {
            setOverlapKeys(getOverlappingKeys(validHolidayData));
            formIsValid = false;
            setFormData((prev) => ({
                ...prev,
                holidayErr: true,
                holidayErrText: 'Some holiday date ranges overlap. Please ensure no dates fall within another holiday range.'
            }));
        } else {
            setOverlapKeys([]);
        }

        return formIsValid;
    };

    const onCancel = () => {
        props.onCancel();
    }

    const handleInputChange = (key, value) => {
        setFormData((prev) => ({ ...prev, [key]: value }));
    };

    const AddUpdateTemplate = async (e) => {
        if (validate(e)) {
            try {
                const dataForm = new FormData();
                dataForm.append("id", props?.masterData?._id ?? '');
                dataForm.append("TitleName", formData?.academicYearName?.trim()?.replace(/\s+/g, ' '));
                const formatedValue = formData?.calendarTemplateValues?.map(x => {
                    const [startDate, endDate] = x?.dateRange || [];
                    return {
                        StartDate: startDate ? moment(startDate).format("YYYY-MM-DD") : '',
                        EndDate: endDate ? moment(endDate).format("YYYY-MM-DD") : '',
                        ApplicableClass: x?.classesApplicable?.length > 1 ? x?.classesApplicable?.join(',') : x?.classesApplicable[0]
                    }
                })
                dataForm.append("CalendarValue", JSON.stringify(formatedValue));
                dataForm.append("ClassType", formData?.classType);
                dataForm.append("CreatedBy", securityUserID);
                if (!CommonConfig.isEmpty(holidaySettings)) {
                    dataForm.append("HolidaySettings", JSON.stringify(holidaySettings));
                }
                if (excelData.length > 0) {
                    dataForm.append("HolidayData", JSON.stringify(excelData));
                }
                Loader.show();
                await api
                    .post(APIConstant.path.AddUpdateAcademicCalander, dataForm, {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    })
                    .then((response) => {
                        let res = response;
                        if (res.success) {
                            Toast.success({ message: res.message });
                            Loader.hide();
                            onCancel();
                        } else {
                            Toast.error({ message: res.message });
                            Loader.hide();
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                        Toast.error({ message: err?.data?.message });
                        Loader.hide();
                    });
            } catch (err) {
                console.log(err);
                Toast.error({ message: err });
                Loader.hide();
                onCancel();
                catchResponse(err);
            }
        }
    };

    const parseDMY = (str) => {
        const [d, m, y] = str.split('/').map(Number);
        return new Date(y, m - 1, d);
    };

    const handleFileUpload = async (e) => {
        const dateRange = formData.calendarTemplateValues[0]?.dateRange;

        if (!dateRange || !dateRange[0]) {
            Toast.error({ message: 'Please select a date range before importing Excel file' });
            importFileUploadRef.current?.clear();
            return;
        }

        const file = e.files?.[0];
        if (!file) return;

        const fileExt = file.name.toLowerCase().slice(file.name.lastIndexOf('.'));
        const validExts = ['.xlsx', '.xls', '.csv'];

        if (!validExts.includes(fileExt)) {
            Toast.error({ message: 'Please upload only .xlsx, .xls or .csv files.' });
            importFileUploadRef.current?.clear();
            return;
        }

        setExcelFileName(file.name);
        setFormData(prev => ({ ...prev, importFile: file }));

        try {
            let rows = [];

            if (fileExt === '.csv') {
                const csvText = await file.text();
                rows = parseCSV(csvText);
            } else {
                const arrayBuffer = await file.arrayBuffer();
                const workbook = new ExcelJS.Workbook();

                await workbook.xlsx.load(arrayBuffer);

                const worksheet = workbook.worksheets[0];
                if (!worksheet) {
                    throw new Error('No worksheet found in the file.');
                }

                let dataFound = false;

                worksheet.eachRow({ includeEmpty: false }, (row, rowNumber) => {
                    if (rowNumber === 1) return;

                    if (row.values && row.values.length > 1) {
                        dataFound = true;
                        const values = row.values;

                        rows.push({
                            srNo: values[1] ?? (rows.length + 1),
                            StartDate: normalizeDate(values[2]),
                            EndDate: normalizeDate(values[3]),
                            Name: values[4]?.toString().trim() || '',
                            Remark: values[5]?.toString().trim() || '',
                            Type: values[6]?.toString().trim() === 'Event' ? 'Event' : 'Holiday',
                            isEdit: false,
                            isAutoGenerated: false,
                            rowNumber: rowNumber // Track row number for error messages
                        });
                    }
                });
                if (rows.length === 0 && !dataFound) {
                    Toast.error({ message: 'No data rows found in the file (check if headers match expected columns).' });
                    clearFileInput();
                    return;
                }
            }
            if (rows.length === 0) {
                Toast.error({ message: 'No data found in the file.' });
                clearFileInput();
                return;
            }

            // Validate mandatory fields
            const missingFieldsRows = [];
            rows.forEach((row, index) => {
                const rowNum = row.rowNumber || index + 2; // +2 because index starts at 0 and row 1 is header
                const missingFields = [];

                if (!row.StartDate || row.StartDate === 'Invalid Date') {
                    missingFields.push('Start Date');
                }
                if (!row.EndDate || row.EndDate === 'Invalid Date') {
                    missingFields.push('End Date');
                }
                if (!row.Name || row.Name.trim() === '') {
                    missingFields.push('Name');
                }

                if (missingFields.length > 0) {
                    missingFieldsRows.push({ rowNum, fields: missingFields });
                }
            });

            if (missingFieldsRows.length > 0) {
                const errorMessages = missingFieldsRows.slice(0, 5).map(item =>
                    `Row ${item.rowNum}: Missing ${item.fields.join(', ')}`
                ).join('; ');

                const additionalCount = missingFieldsRows.length > 5 ? ` and ${missingFieldsRows.length - 5} more` : '';

                Toast.error({
                    message: `Mandatory fields missing: ${errorMessages}${additionalCount}. Please ensure Start Date, End Date, and Name are provided for all rows.`
                });
                clearFileInput();
                return;
            }

            const [rangeStart, rangeEnd] = dateRange;
            const startLimit = parseToDate(rangeStart);
            const endLimit = rangeEnd ? parseToDate(rangeEnd) : startLimit;

            if (isNaN(startLimit) || isNaN(endLimit)) {
                Toast.error({ message: 'Invalid selected date range. Please select a valid range.' });
                clearFileInput();
                return;
            }

            const validatedRows = rows.filter(row => {
                const rowStart = parseToDate(row.StartDate);
                const rowEnd = row.EndDate ? parseToDate(row.EndDate) : rowStart;

                if (isNaN(rowStart) || isNaN(rowEnd)) return false;
                if (row.EndDate && rowStart > rowEnd) return false;

                const withinStart = rowStart >= startLimit && rowStart <= endLimit;
                const withinEnd = rowEnd >= startLimit && rowEnd <= endLimit;

                return withinStart && withinEnd;
            });

            if (validatedRows.length === 0) {
                Toast.error({ message: 'No valid records found within the selected date range or dates are invalid.' });
                clearFileInput();
                return;
            }

            if (validatedRows.length < rows.length) {
                Toast.error({ message: `${rows.length - validatedRows.length} record(s) skipped due to invalid dates or being outside date range.` });
                setExcelFileName("");
                setFormData((prev) => ({ ...prev, importFile: null }));
                if (importFileUploadRef.current) {
                    importFileUploadRef.current.clear();
                }
            }

            const cleanedRows = validatedRows.map(row => {
                const { rowNumber, ...cleanRow } = row;
                return cleanRow;
            });

            setExcelData(prevData => {
                const existingManual = prevData.filter(rec => !rec.isAutoGenerated);
                const autoGenerated = prevData.filter(rec => rec.isAutoGenerated);
                const combined = [...existingManual, ...cleanedRows];
                const filteredCombined = removeDuplicateHolidays(combined, autoGenerated);
                const final = [...filteredCombined, ...autoGenerated];
                const uniqueRecords = removeDuplicates(final);

                return uniqueRecords
                    .sort((a, b) => parseDMY(a.StartDate) - parseDMY(b.StartDate))
                    .map((rec, idx) => ({ ...rec, srNo: idx + 1 }));
            });

        } catch (error) {
            console.error('Excel parsing failed:', error);
            let msg = 'Failed to read the file. Please try a different file.';
            if (error.message.includes('zip') || error.message.includes('central directory')) {
                msg = 'Invalid or corrupted Excel (.xlsx/.xls) file. Try re-saving it in Excel.';
            } else if (error.message.includes('F_OK') || error.message.includes('fs.constants')) {
                msg = 'File system error. Please ensure you are using the browser version of ExcelJS.';
            } else if (fileExt === '.csv' && error.message.includes('CSV')) {
                msg = 'Invalid CSV format. Check for proper delimiters and encoding.';
            }
            Toast.error({ message: msg });
            clearFileInput();
        }
    };

    const parseToDate = (value) => {
        if (!value) return new Date('Invalid');

        if (value instanceof Date) return value;

        if (typeof value === 'number') {
            const excelEpoch = new Date(1899, 11, 30);
            return new Date(excelEpoch.getTime() + value * 86400000);
        }

        if (typeof value === 'string') {
            const val = value.trim();

            if (/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(val)) {
                return parseDDMMYYYY(val);
            }

            if (/^\d{1,2}-\d{1,2}-\d{4}$/.test(val)) {
                const [d, m, y] = val.split('-');
                return new Date(`${y}-${m.padStart(2, '0')}-${d.padStart(2, '0')}`);
            }

            return new Date(val);
        }
        try {
            return new Date(value);
        } catch {
            return new Date('Invalid');
        }
    };

    const parseDDMMYYYY = (str) => {
        if (!str || typeof str !== 'string') return new Date('Invalid');
        const [d, m, y] = str.split('/');
        return new Date(`${y}-${m}-${d}`);
    };

    const parseCSV = (csvText) => {
        const lines = csvText.split('\n').filter(line => line.trim());
        const rows = [];

        for (let i = 1; i < lines.length; i++) {
            const values = lines[i]?.split(',')?.map(v => v?.trim()?.replace(/^["']|["']$/g, ''));

            if (values.length > 0 && values[0]) {
                rows.push({
                    srNo: values[0] || (rows.length + 1),
                    StartDate: normalizeDate(values[1]),
                    EndDate: normalizeDate(values[2]),
                    Name: values[3]?.trim() || '',
                    Remark: values[4]?.trim() || '',
                    Type: values[5]?.trim() === 'Event' ? 'Event' : 'Holiday',
                    isEdit: false,
                    isAutoGenerated: false
                });
            }
        }

        return rows;
    };

    const normalizeDate = (value) => {
        if (!value) return '';

        const formatToDDMMYYYY = (date) => {
            if (!(date instanceof Date) || isNaN(date)) return 'Invalid Date';
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            return `${day}/${month}/${year}`;
        };

        // Parse DD/MM/YYYY or DD-MM-YYYY manually (IMPORTANT FIX)
        const parseDMY = (d, m, y) => {
            const day = Number(d);
            const month = Number(m);
            const year = Number(y);
            const date = new Date(year, month - 1, day); // FORCE D-M-Y
            return date;
        };

        if (value instanceof Date) {
            return formatToDDMMYYYY(value);
        }

        if (typeof value === 'string') {
            const val = value.trim();

            // DD/MM/YYYY
            if (/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(val)) {
                const [d, m, y] = val.split('/');
                return formatToDDMMYYYY(parseDMY(d, m, y));
            }

            // DD-MM-YYYY
            if (/^\d{1,2}-\d{1,2}-\d{4}$/.test(val)) {
                const [d, m, y] = val.split('-');
                return formatToDDMMYYYY(parseDMY(d, m, y));
            }

            // Last fallback → attempt natural parsing
            const date = new Date(val);
            if (!isNaN(date.getTime())) {
                return formatToDDMMYYYY(date);
            }

            return 'Invalid Date';
        }

        if (typeof value === 'number') {
            const excelEpoch = new Date(1899, 11, 30);
            const date = new Date(excelEpoch.getTime() + value * 86400000);
            return formatToDDMMYYYY(date);
        }

        return value?.result?.toString().trim() || value.toString().trim() || '';
    };

    const clearFileInput = () => {
        importFileUploadRef.current?.clear();
        setExcelFileName('');
        setFormData(prev => ({ ...prev, importFile: null }));
    };

    const downloadSampleCSV = () => {
        const sampleData = [
            ['Sr. no.', 'Start Date', 'End Date', 'Name', 'Remark'],
            ['1', '01/01/2024', '31/01/2024', 'Winter Break', 'School Holiday'],
            ['2', '15/03/2024', '20/03/2024', 'Spring Break', 'Mid-term Holiday'],
            ['3', '01/06/2024', '15/06/2024', 'Summer Vacation', 'Annual Holiday'],
        ];

        const csvContent = sampleData.map(row => row.join(',')).join('\n');

        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);

        link.setAttribute('href', url);
        link.setAttribute('download', 'Sample_Academic_Calendar.csv');
        link.style.visibility = 'hidden';

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        Toast.success({ message: 'Sample CSV file downloaded successfully!' });
    };

    const renderFooter = () => (
        <div className="dialog-footer p-d-flex p-ai-center p-jc-end">
            <Button
                label="Cancel"
                className="btn-text-action-secondary"
                onClick={handleClose}
            />
            <Button
                label="Delete"
                className="btn-text-action-primary"
                onClick={() => {
                    handleClose();
                    setFormData((prev) => ({ ...prev, previewImportFile: '', importFile: '' }));
                    if (importFileUploadRef.current) {
                        importFileUploadRef.current.clear();
                    }
                }}
            />
        </div>
    );

    const renderExcelDeleteFooter = () => (
        <div className="dialog-footer p-d-flex p-ai-center p-jc-end">
            <Button
                label="Cancel"
                className="btn-text-action-secondary"
                onClick={handleCloseExcelConfirmation}
            />
            <Button
                label="Delete"
                className="btn-text-action-primary"
                onClick={() => {
                    handleCloseExcelConfirmation();
                    setExcelFileName("");
                    setFormData((prev) => ({ ...prev, importFile: null }));
                    if (importFileUploadRef.current) {
                        importFileUploadRef.current.clear();
                    }
                    Toast.success({ message: 'Excel file removed successfully' });
                }}
            />
        </div>
    );

    const renderHolidayDeleteFooter = () => (
        <div className="dialog-footer p-d-flex p-ai-center p-jc-end">
            <Button
                label="Cancel"
                className="btn-text-action-secondary"
                onClick={handleCloseHolidayConfirmation}
            />
            <Button
                label="Delete"
                className="btn-text-action-primary"
                onClick={() => {
                    handleCloseHolidayConfirmation();
                    const updatedData = excelData
                        .filter((_, i) => i !== deletedIndex)
                        .map((row, idx) => ({ ...row, srNo: idx + 1 }));
                    setExcelData(updatedData);
                    Toast.success({ message: 'Row deleted successfully' });
                }}
            />
        </div>
    );

    const getDateOnly = (date) => {
        if (!date) return null;
        const d = new Date(date);
        return new Date(d.getFullYear(), d.getMonth(), d.getDate());
    };

    const handleClassChange = (index, value) => {
        setFormData((prev) => {
            const updatedCalendarTemplateValues = [...prev.calendarTemplateValues];
            updatedCalendarTemplateValues[index] = {
                ...updatedCalendarTemplateValues[index],
                classesApplicable: value
            };

            return {
                ...prev,
                calendarTemplateValues: updatedCalendarTemplateValues
            };
        });
    };

    const handleDateRangeChange = (index, value) => {
        let [startDate, endDate] = value || [];
        startDate = getDateOnly(startDate);
        endDate = getDateOnly(endDate);

        setFormData((prev) => {
            const updated = [...prev.calendarTemplateValues];

            if (startDate && endDate) {
                if (startDate > endDate) {
                    updated[index] = {
                        ...updated[index],
                        dateRange: value,
                        dateRangeErr: true,
                        dateRangeErrText: "'Start' date cannot be after 'End' date."
                    };
                } else if (startDate.getTime() === endDate.getTime()) {
                    updated[index] = {
                        ...updated[index],
                        dateRange: value,
                        dateRangeErr: true,
                        dateRangeErrText: "'Start' and 'End' date cannot be the same."
                    };
                } else {
                    updated[index] = {
                        ...updated[index],
                        dateRange: value,
                        dateRangeErr: false,
                        dateRangeErrText: ''
                    };
                }
            } else {
                updated[index] = {
                    ...updated[index],
                    dateRange: value
                };
            }

            return {
                ...prev,
                calendarTemplateValues: updated
            };
        });
    };

    const handleHolidayChange = (key, value) => {
        setHolidaySettings((prev) => ({ ...prev, [key]: value }));
    };

    const handleExcelFieldChange = (rowIndex, field, value) => {
        setExcelData(prev => {
            const updated = [...prev];
            updated[rowIndex] = {
                ...updated[rowIndex],
                [field]: value
            };
            return updated;
        });
    };

    const addNewExcelRow = () => {
        const dateRange = formData.calendarTemplateValues[0]?.dateRange;

        if (!dateRange || !dateRange[0]) {
            Toast.error({ message: 'Please select a date range before adding new records' });
            return;
        }

        const newRow = {
            srNo: 1,
            StartDate: '',
            EndDate: '',
            Name: '',
            Remark: '',
            Type: 'Holiday',
            isEdit: true,
            isAutoGenerated: false
        };

        setExcelData(prev => {
            const updated = [newRow, ...prev];
            return updated.map((row, idx) => ({ ...row, srNo: idx + 1 }));
        });

        Toast.success({ message: 'New row added' });
    };

    const dateBodyTemplate = (rowData, { rowIndex }) => {
        return (
            <div className="custom-inputs">
                <Calendar
                    id="dateRange"
                    value={rowData?.dateRange}
                    onChange={(e) => handleDateRangeChange(rowIndex, e.value)}
                    selectionMode="range"
                    readOnlyInput
                    dateFormat="dd/mm/yy"
                    className="p-w-100"
                    showButtonBar
                    placeholder='Select Date Range'
                />
                <span className="error-msg" style={{ color: 'red' }}>
                    {rowData?.dateRangeErr ? rowData?.dateRangeErrText : null}
                </span>
            </div>
        )
    };

    const classBodyTemplate = useCallback((rowData, { rowIndex }) => {
        return (
            <div className="custom-inputs">
                <MultiSelect
                    id="className"
                    value={rowData?.classesApplicable}
                    options={classList}
                    onChange={(e) => handleClassChange(rowIndex, e.value)}
                    placeholder="Select Classes"
                    display="chip"
                    className='p-w-100 e-multy-select'
                    filter
                />
            </div>
        );
    }, [classList]);

    const addCalenderValue = () => {
        const newValue = {
            dateRange: null,
            dateRangeErr: false,
            dateRangeErrText: '',
            classesApplicable: []
        };

        setFormData((prev) => ({
            ...prev,
            calendarTemplateValues: [...(prev.calendarTemplateValues || []), newValue]
        }));
    };

    const removeCalendarValue = (index) => {
        setFormData((prev) => {
            const updated = [...(prev.calendarTemplateValues || [])].filter((_, i) => i !== index);
            return {
                ...prev,
                calendarTemplateValues: updated
            };
        });
    };

    const actionsBodyTemplate = (rowData, { rowIndex }) => (
        <div className="p-d-flex p-jc-start">
            {rowIndex === formData?.calendarTemplateValues?.length - 1 &&
                <Button
                    icon="pi pi-plus"
                    className="e-sction-btn p-m-0 p-m-2"
                    onClick={() => addCalenderValue()}
                />}
            {(rowIndex !== 0 || formData?.calendarTemplateValues.length > 1) &&
                <Button icon="pi pi-trash" className="e-sction-btn p-m-0 p-m-2"
                    onClick={() => removeCalendarValue(rowIndex)}
                />
            }
        </div>
    );

    const excelSrNoBodyTemplate = (rowData) => {
        return <span>{rowData.srNo}</span>;
    };

    const parseDDMMYYYYToDate = (str) => {
        if (!str || typeof str !== 'string') return null;
        const parts = str.split('/');
        if (parts.length !== 3) return null;

        const [dStr, mStr, yStr] = parts;
        const d = Number(dStr);
        const m = Number(mStr);
        const y = Number(yStr);

        if (!Number.isInteger(d) || !Number.isInteger(m) || !Number.isInteger(y)) return null;
        if (y < 1000 || m < 1 || m > 12 || d < 1 || d > 31) return null;

        // Construct in ISO order to avoid locale ambiguity
        const date = new Date(`${y}-${String(m).padStart(2, '0')}-${String(d).padStart(2, '0')}`);
        return isNaN(date) ? null : date;
    };

    const formatToDDMMYYYY = (date) => {
        if (!(date instanceof Date) || isNaN(date)) return '';
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };

    const excelStartDateBodyTemplate = (rowData, { rowIndex }) => {
        if (rowData?.isEdit) {
            const dateValue = parseDDMMYYYYToDate(rowData?.StartDate);
            return (
                <Calendar
                    value={dateValue}
                    minDate={academicStartDate}
                    maxDate={academicEndDate}
                    onChange={(e) => {
                        const selectedDate = e.value;
                        if (selectedDate) {
                            const formatted = selectedDate ? formatToDDMMYYYY(selectedDate) : '';
                            handleExcelFieldChange(rowIndex, 'StartDate', formatted);
                        } else {
                            handleExcelFieldChange(rowIndex, 'StartDate', '');
                        }
                    }}
                    dateFormat="dd/mm/yy"
                    placeholder="dd/mm/yyyy"
                    className="p-w-100"
                    showButtonBar
                    readOnlyInput
                />
            );
        }
        return <span>{rowData?.StartDate}</span>;
    };

    const excelEndDateBodyTemplate = (rowData, { rowIndex }) => {
        if (rowData?.isEdit) {
            const dateValue = parseDDMMYYYYToDate(rowData?.EndDate);
            const rowStartDate = parseDDMMYYYYToDate(rowData?.StartDate);
            return (
                <Calendar
                    value={dateValue}
                    minDate={rowStartDate || academicStartDate}
                    maxDate={academicEndDate}
                    onChange={(e) => {
                        const selectedDate = e.value;
                        if (selectedDate) {
                            const formatted = selectedDate ? formatToDDMMYYYY(selectedDate) : '';
                            handleExcelFieldChange(rowIndex, 'EndDate', formatted);
                        } else {
                            handleExcelFieldChange(rowIndex, 'EndDate', '');
                        }
                    }}
                    dateFormat="dd/mm/yy"
                    placeholder="dd/mm/yyyy"
                    className="p-w-100"
                    showButtonBar
                    readOnlyInput
                />
            );
        }
        return <span>{rowData?.EndDate}</span>;
    };

    const excelNameBodyTemplate = (rowData, { rowIndex }) => {
        if (rowData?.isEdit) {
            return (
                <InputText
                    value={rowData?.Name}
                    onChange={(e) => handleExcelFieldChange(rowIndex, 'Name', e.target.value)}
                    placeholder="Enter name"
                    className="p-w-100"
                    style={{ fontSize: '14px' }}
                />
            );
        }
        return <span>{rowData?.Name}</span>;
    };

    const excelRemarkBodyTemplate = (rowData, { rowIndex }) => {
        if (rowData?.isEdit) {
            return (
                <InputText
                    value={rowData?.Remark}
                    onChange={(e) => handleExcelFieldChange(rowIndex, 'Remark', e.target.value)}
                    placeholder="Enter remark"
                    className="p-w-100"
                    style={{ fontSize: '14px' }}
                />
            );
        }
        return <span>{rowData?.Remark}</span>;
    };

    const excelTypeBodyTemplate = (rowData, { rowIndex }) => {
        const type = rowData?.Type || 'Holiday';
        if (rowData?.isEdit) {
            return (
                <Dropdown
                    value={type}
                    options={[{ label: 'Holiday', value: 'Holiday' }, { label: 'Event', value: 'Event' }]}
                    onChange={(e) => handleExcelFieldChange(rowIndex, 'Type', e.value)}
                    className="p-w-100"
                    style={{ fontSize: '14px' }}
                />
            );
        }
        return <span>{type}</span>;
    };

    const excelActionsBodyTemplate = (rowData, { rowIndex }) => {
        return (
            <div className="p-d-flex p-jc-start">
                {rowData?.isEdit ? (
                    <Button
                        icon="pi pi-check"
                        className="e-sction-btn p-m-0 p-m-2"
                        onClick={() => {
                            if (!rowData?.StartDate) {
                                Toast.error({ message: 'Please enter Start Date' });
                                return;
                            }

                            if (!rowData?.EndDate) {
                                Toast.error({ message: 'Please enter End Date' });
                                return;
                            }

                            if (!rowData?.Name?.trim()) {
                                Toast.error({ message: 'Please enter Holiday Name' });
                                return;
                            }
                            setExcelData(prev => {
                                const updated = [...prev];
                                updated[rowIndex] = {
                                    ...updated[rowIndex],
                                    isEdit: false
                                };
                                return updated;
                            });
                            Toast.success({ message: 'Row updated successfully' });

                        }}
                        tooltip="Save"
                        tooltipOptions={{ position: 'top' }}
                    />
                ) : (
                    <Button
                        icon="pi pi-pencil"
                        className="e-sction-btn p-m-0 p-m-2"
                        onClick={() => {
                            setExcelData(prev => {
                                const updated = [...prev];
                                updated[rowIndex] = {
                                    ...updated[rowIndex],
                                    isEdit: true
                                };
                                return updated;
                            });
                        }}
                        tooltip="Edit"
                        tooltipOptions={{ position: 'top' }}
                    />
                )}
                <Button
                    icon="pi pi-trash"
                    className="e-sction-btn p-m-0 p-m-2"
                    onClick={() => {
                        setIsDeleteHolidayConfirmation(true);
                        setDeletedIndex(rowIndex);
                    }}
                    tooltip="Delete"
                    tooltipOptions={{ position: 'top' }}
                />
            </div>
        );
    };

    return (
        <div className="p-d-flex p-flex-column p-jc-between">
            <div className='p-grid' style={{ maxHeight: 'calc(100vh - 250px)', overflowY: 'auto', marginInline: '-24px', paddingInline: '24px' }}>
                <div className="p-col-12 p-md-4 p-pt-2">
                    <div className="custom-inputs">
                        <label htmlFor="academicYearName">Academic Year Name</label>
                        <div className="custom-inputs">
                            <InputText
                                ref={academicYearNameRef}
                                id="academicYearName"
                                value={formData?.academicYearName}
                                maxLength={15}
                                className='p-mt-1 p-w-100'
                                onChange={(e) => handleInputChange("academicYearName", e.target.value)}
                                style={{
                                    fontFamily: "Noto Sans, Arial, sans-serif"
                                }}
                            />
                            <span className="error-msg" style={{ color: 'red' }}>
                                {formData?.academicYearNameErr ? formData?.academicYearNameErrText : null}
                            </span>
                        </div>
                    </div>
                </div>
                <div className="p-col-12 p-md-4 p-pt-2">
                    <div className="p-d-flex p-ai-center p-pt-5 p-mt-1">
                        <div className="p-mr-3">
                            <Checkbox
                                inputId="classWise"
                                disabled={props?.configId}
                                checked={formData?.classType === 'classWise'}
                                onChange={() => {
                                    GetClassList(securityUserID, 'classWise')
                                    setFormData((prev) => {
                                        const updatedCalendarTemplateValues = prev.calendarTemplateValues.map(item => ({
                                            ...item,
                                            classesApplicable: []
                                        }));

                                        return {
                                            ...prev,
                                            calendarTemplateValues: updatedCalendarTemplateValues
                                        };
                                    });
                                }}
                            />
                            <label htmlFor="classWise" className="p-ml-2">Class Wise</label>
                        </div>
                        <div>
                            <Checkbox
                                inputId="sectionWise"
                                disabled={props?.configId}
                                checked={formData?.classType === 'sectionWise'}
                                onChange={() => {
                                    GetClassList(securityUserID, 'sectionWise');
                                    setFormData((prev) => {
                                        const updatedCalendarTemplateValues = prev.calendarTemplateValues.map(item => ({
                                            ...item,
                                            classesApplicable: []
                                        }));

                                        return {
                                            ...prev,
                                            calendarTemplateValues: updatedCalendarTemplateValues
                                        };
                                    });
                                }}
                            />
                            <label htmlFor="sectionWise" className="p-ml-2">Section Wise</label>
                        </div>
                    </div>
                </div>
                <div className="p-col-12 p-md-4 p-pt-2">
                    <div>
                        <label htmlFor="importFile">Import Excel File</label>
                        <div className="p-d-flex p-flex-column p-jc-around p-mt-2">
                            {excelFileName && (
                                <div className="p-mb-2 p-d-flex p-ai-center">
                                    <i className="pi pi-file-excel" style={{ fontSize: '1.5rem', color: '#00A651', marginRight: '10px' }}></i>
                                    <span style={{ fontWeight: 'bold' }}>{excelFileName}</span>
                                </div>
                            )}
                            <div className='p-d-flex p-ai-center user-profile-btn'>
                                {!excelFileName && (
                                    <>
                                        <FileUpload
                                            ref={importFileUploadRef}
                                            name='importFile'
                                            customUpload
                                            auto
                                            mode="basic"
                                            uploadHandler={handleFileUpload}
                                            className="small-file-upload"
                                            accept=".xlsx,.xls,.csv"
                                        />
                                        <Button
                                            icon="pi pi-download"
                                            label="Sample"
                                            className="p-button-outlined p-button-secondary p-ml-2"
                                            onClick={downloadSampleCSV}
                                            tooltip="Download Sample CSV"
                                            tooltipOptions={{ position: 'top' }}
                                            style={{ height: '36px' }}
                                        />
                                    </>
                                )}
                                {excelFileName && (
                                    <div
                                        className="error-msg-alert p-ml-2"
                                        style={{
                                            cursor: "pointer",
                                        }}
                                        onClick={() => {
                                            setIsDeleteExcelConfirmation(true);
                                        }}
                                    >
                                        <i className="pi pi-trash" style={{ fontSize: "16px", color: "red" }}></i>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                <div className='p-col-12 p-pt-3'>
                    <h4>Calendar Template Values</h4>
                    <div className='e-grade-master-table p-w-100'>
                        <DataTable value={formData?.calendarTemplateValues} responsiveLayout="scroll" className="main-table table-td">
                            <Column header="Date Range" body={dateBodyTemplate} />
                            <Column header="Class" body={classBodyTemplate} />
                            <Column header="Actions" body={actionsBodyTemplate} />
                        </DataTable>
                    </div>
                </div>
                <div className="p-col-12 p-pt-3">
                    <h4>Holiday Settings</h4>
                    <div className="p-grid">
                        <div className="p-col-12 p-md-4 p-pt-2">
                            <Checkbox
                                inputId="everySunday"
                                checked={holidaySettings?.EverySunday}
                                onChange={(e) => handleHolidayChange('EverySunday', e.checked)}
                            />
                            <label htmlFor="everySunday" className="p-ml-2">Every Sunday</label>
                        </div>
                        <div className="p-col-12 p-md-4 p-pt-2">
                            <Checkbox
                                inputId="firstSaturday"
                                checked={holidaySettings?.FirstSaturday}
                                onChange={(e) => handleHolidayChange('FirstSaturday', e.checked)}
                            />
                            <label htmlFor="firstSaturday" className="p-ml-2">Every 1st Saturday of Month</label>
                        </div>
                        <div className="p-col-12 p-md-4 p-pt-2">
                            <Checkbox
                                inputId="secondSaturday"
                                checked={holidaySettings?.SecondSaturday}
                                onChange={(e) => handleHolidayChange('SecondSaturday', e.checked)}
                            />
                            <label htmlFor="secondSaturday" className="p-ml-2">Every 2nd Saturday of Month</label>
                        </div>
                        <div className="p-col-12 p-md-4 p-pt-2">
                            <Checkbox
                                inputId="thirdSaturday"
                                checked={holidaySettings?.ThirdSaturday}
                                onChange={(e) => handleHolidayChange('ThirdSaturday', e.checked)}
                            />
                            <label htmlFor="thirdSaturday" className="p-ml-2">Every 3rd Saturday of Month</label>
                        </div>
                        <div className="p-col-12 p-md-4 p-pt-2">
                            <Checkbox
                                inputId="fourthSaturday"
                                checked={holidaySettings?.FourthSaturday}
                                onChange={(e) => handleHolidayChange('FourthSaturday', e.checked)}
                            />
                            <label htmlFor="fourthSaturday" className="p-ml-2">Every 4th Saturday of Month</label>
                        </div>
                    </div>
                </div>

                <span className="error-msg" style={{ color: 'red' }}>
                    {formData?.holidayErr ? formData?.holidayErrText : null}
                </span>

                {excelData?.length > 0 && (
                    <div className="p-col-12 p-pt-3">
                        <div className="p-d-flex p-jc-between p-ai-center p-mb-2">
                            <h4>Holiday Data</h4>
                            <Button
                                icon="pi pi-plus"
                                label="Add Row"
                                className="btn-text-action-primary"
                                onClick={addNewExcelRow}
                            />
                        </div>
                        <div className='e-grade-master-table p-w-100'>
                            <DataTable
                                value={excelData}
                                responsiveLayout="scroll"
                                className="main-table table-td"
                                paginator
                                rows={10}
                                rowsPerPageOptions={[5, 10, 25, 50]}
                                paginatorTemplate="RowsPerPageDropdown CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink JumpToPageInput"
                                currentPageReportTemplate="Showing {first}-{last} of {totalRecords} records"
                                editMode="row"
                                rowClassName={(rowData) => {
                                    return overlapKeys.includes(getRowKey(rowData)) ? "overlap-row" : "";
                                }}
                            >
                                <Column header="Sr. No." body={excelSrNoBodyTemplate} style={{ width: '80px' }} />
                                <Column header="Start Date" body={excelStartDateBodyTemplate} />
                                <Column header="End Date" body={excelEndDateBodyTemplate} />
                                <Column header="Name" body={excelNameBodyTemplate} />
                                <Column header="Type" body={excelTypeBodyTemplate} style={{ width: '130px' }} />
                                <Column header="Remark" body={excelRemarkBodyTemplate} />
                                <Column header="Actions" body={excelActionsBodyTemplate} style={{ width: '120px' }} />
                            </DataTable>
                        </div>
                    </div>
                )}
            </div>
            <div className='dialog-footer p-d-flex p-ai-center p-jc-end p-mt-3'>
                <Button className='p-m-0 btn-text-action-secondary p-m-1' onClick={() => onCancel()}>Cancel</Button>
                <Button className='p-m-0 btn-text-action-primary' label="Save" severity="secondary" raised onClick={() => AddUpdateTemplate()} />
            </div>

            <Dialog
                visible={isDeleteConfirmation}
                onHide={handleClose}
                header={
                    <div className="p-d-flex p-jc-between p-ai-center">
                        <span>Delete Confirmation</span>
                    </div>
                }
                footer={renderFooter()}
                draggable={false}
                dismissableMask
                position="center"
                style={{ width: '450px' }}
            >
                <DeleteConfirmation />
            </Dialog>

            <Dialog
                visible={isDeleteExcelConfirmation}
                onHide={handleCloseExcelConfirmation}
                header={
                    <div className="p-d-flex p-jc-between p-ai-center">
                        <span>Delete Excel File</span>
                    </div>
                }
                footer={renderExcelDeleteFooter()}
                draggable={false}
                dismissableMask
                position="center"
                style={{ width: '450px' }}
            >
                <div className="p-d-flex p-ai-center">
                    <i className="pi pi-exclamation-triangle" style={{ fontSize: '2rem', color: '#FFA726', marginRight: '1rem' }}></i>
                    <span>Are you sure you want to delete this Excel file and all its data?</span>
                </div>
            </Dialog>
            <Dialog
                visible={isDeleteHolidayConfirmation}
                onHide={handleCloseHolidayConfirmation}
                header={
                    <div className="p-d-flex p-jc-between p-ai-center">
                        <span>Delete Holiday</span>
                    </div>
                }
                footer={renderHolidayDeleteFooter()}
                draggable={false}
                dismissableMask
                position="center"
                style={{ width: '450px' }}
            >
                <div className="p-d-flex p-ai-center">
                    <i className="pi pi-exclamation-triangle" style={{ fontSize: '2rem', color: '#FFA726', marginRight: '1rem' }}></i>
                    <span>Are you sure you want to delete this holiday?</span>
                </div>
            </Dialog>
        </div>
    );
};

export default AddEditAcademicCalender;